// info and before after block js

document.addEventListener("DOMContentLoaded", function(){
    // refactored a js slider -> https://codecanel.com/before-and-after-image-slider-js/
    
    const sliderHandle = document.querySelector('.slider-handle');
    const afterImage = document.querySelector('.after-image');
    const sliderContainer = document.querySelector('.slider-container');

    let isDragging = false;

    const handleDrag = (xPos) => {
        const rect = sliderContainer.getBoundingClientRect();
        xPos = Math.max(0, Math.min(xPos - rect.left, rect.width)); // Ensure xPos stays within bounds
    
        // Move the slider handle
        sliderHandle.style.left = `${xPos}px`;
    
        // Clip the after image
        afterImage.style.clip = `rect(0, ${xPos}px, 1000px, 0)`;
    };
    
    const startDrag = () => isDragging = true;
    const stopDrag = () => isDragging = false;
    
    const moveHandler = (event) => {
        if(isDragging){
            const xPos = event.touches ? event.touches[0].clientX : event.clientX;
            handleDrag(xPos);
        }
    };
    
    // Mouse Events
    sliderHandle.addEventListener('mousedown', startDrag);
    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('mousemove', moveHandler);
    
    // Touch Events
    sliderHandle.addEventListener('touchstart', startDrag);
    document.addEventListener('touchend', stopDrag);
    document.addEventListener('touchmove', moveHandler);
    
    // Initial values
    const rect = sliderContainer.getBoundingClientRect();
    sliderHandle.style.left = `200px`;
    afterImage.style.clip = `rect(0, 200px, 1000px, 0)`;

    function updateSlider(){
        const rect = sliderContainer.getBoundingClientRect();
        sliderHandle.style.left = `200px`;
        afterImage.style.clip = `rect(0, 200px, 1000px, 0)`;
    }
      
    // Run on load
    window.addEventListener('DOMContentLoaded', updateSlider);
    
    // Run on resize
    window.addEventListener('resize', updateSlider);
    
    // Run on orientation change (mobile)
    window.addEventListener('orientationchange', updateSlider);
});

(($) => {

    // sliders, with name of block at the start

    function initSliders(){

        const slider__one = $('.text_and_svgs_scrolling .scrolling_container');
        if(slider__one.length){
            slider__one.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 4000,
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                pauseOnHover: false,
            });
        }
    
        const slider__two = $('.text_and_variable_svgs_scrolling .scrolling_container');
        if(slider__two.length){
            slider__two.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 4000,
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                pauseOnHover: false,
            });
        }
    
        const slider__three = $('.svgs_scrolling .scrolling_container');
        if(slider__three.length){
            slider__three.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 3000,
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                pauseOnHover: false,
            });
        }
    }

    function destroySliders(){
        $('.scrolling_container').each(function(){
            if($(this).hasClass('slick-initialized')){
                $(this).slick('unslick');
            }
        });
    }

    // Debounce resize to avoid hammering
    let resizeTimeout;
    $(window).on('resize',function(){
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function(){
            destroySliders();
            initSliders();
        }, 100);
    });

    // Initial call
    $(document).ready(function(){
        initSliders();
    });

    // info image regular carousel

    $('.info_and_image_or_slider .image_side.multiple').slick({
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        fadeSpeed: 1000
    });

    // cards carousel block slider

    function carousel_of_cards(){
        if($('.cards_carousel .posts')[0]){
            $('.cards_carousel .posts').slick({
                slidesToShow: 1,
                arrows: false,
                variableWidth: true,
                cssEase: 'linear',
                dots: false,
                infinite: false,
                pauseOnHover: false,
                mobileFirst: true,
                centerMode: false
            });
        }
    }

    function carousel_of_cards_check(){
        if(window.innerWidth <= 1279 && !$('.cards_carousel .posts').hasClass('slick-initialized')){
            carousel_of_cards();
        }

        if(window.innerWidth >= 1280 && $('.cards_carousel .posts').hasClass('slick-initialized')){
            $('.cards_carousel .posts').slick('unslick');
        }
    }

    carousel_of_cards_check();

    $(window).on('resize', function(){
        carousel_of_cards_check();
    });

    $(window).on('resize', function(){
        $('.slider-handle').css('left', '10px');
    });

    // hover image display info block hover effect that displays info

    $('.image_side__interaction .interaction').on('mouseover', function(e){
        let classes = $(this).attr('class').split(/\s+/);
        let interactionClass = classes.find(c => c.startsWith('interaction--'));
        let number;
        if(interactionClass){
            number = interactionClass.split('--')[1];
        }
        $('.general_block__info_items .info_item_single').removeClass('active');
        $('.image_side__interaction .interaction').removeClass('active');
        $('.general_block__info_items .info_item_single--' + number).addClass('active');
        $('.image_side__interaction .interaction--' + number).addClass('active');
    });

    // hero with video display image until page has loaded then display video

    

})(jQuery);